import { indeterminate } from './../../../../gzProgressSpinner/index.stories';
import { SpinnerWidth } from './../../../../gzProgressSpinner/types/index';
import { LitElement, html, TemplateResult, nothing, css } from 'lit';
import { property, state, query, customElement } from 'lit/decorators.js';

@customElement('gz-load-more-nodes-button')
export class GzLoadMoreNodesButtonWebComponent extends LitElement {
  @property({ type: Number })
  depth = 1;

  @property({ type: String })
  label: string;

  @property({ type: Boolean, attribute: true, reflect: true })
  isLoading = false;

  static styles = css`
    :host {
      --font-family: 'Montserrat', sans-serif;
      display: inline-flex;
      align-items: center;
      box-sizing: border-box;
    }
    gz-button {
      display: inline-flex;
      align-items: center;
      height: calc(3 * var(--spacer));
    }
  `;

  render() {
    const paddingLeft = `margin-left: calc(var(--spacer) * 4 * ${this.depth});`;

    return html`<gz-button style="${paddingLeft}" type="quiet" buttonfontsize="small" lowercase>
      ${this.label}
      ${this.isLoading
        ? html`<gz-progress-spinner style="margin-left: 4px" indeterminate spinnerWidth="small"></gz-progress-spinner>`
        : html`<gz-icon name="ds-icon-arrow_down_expand" color="primary" size="24"></gz-icon>`}
    </gz-button>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-load-more-nodes-button': GzLoadMoreNodesButtonWebComponent;
  }
}
